"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routerPathGroup = exports.apiPathGroup = exports.packageGroup = exports.subjectName = void 0;
exports.subjectName = 'Member Group';
exports.packageGroup = 'member-group';
exports.apiPathGroup = 'member-groups';
exports.routerPathGroup = 'member-group';
